import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxPayee from '../util/remote/ajaxPayee';
import { useVendor } from './VendorContext';

const initialState = { 
    accountId: null,
    accountInfo: null,
    statement: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    dateRange: { opening_date: "", closing_date: "" },
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { ...initialState };  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const VendorStatementContext = createContext();

export const VendorStatementProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const {selectedVendor} = useVendor();

  /**
   * Only call this if the getTransactions has already been called on mount by the AccountStatementPage
   */
  useEffect(()=>{
    if(state.mounted){
      getStatement();
    }
  }, [state.currentPage])

  //Reset mechanism for account
  useEffect(()=>{
    if (state.accountInfo?.account_id) {
      dispatch({ type: "statement", payload: null });
      dispatch({ type: "metaData", payload: null });
      setCurrentPage(1);
    }
  }, [state.accountInfo]);


  const getStatement = async (refresh = false, period = null) => {
    dispatch({ type: "mounted", payload: true });

    if (refresh) {
        dispatch({ type: "statement", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
    }

    const statementPayload = {
        account_id: state.accountInfo?.account_id, // Optional chaining for safety
        payee_id: selectedVendor.payee_id,
        page: refresh ? 1 : state.currentPage,
        opening_balance: refresh ? 0 : state.statement?.summary?.running_opening_balance || 0,
        opening_date: period?.opening_date || state.dateRange?.opening_date,
        closing_date: period?.closing_date || state.dateRange?.closing_date
    };
    const server_response = await ajaxPayee.fetchPayeeStatement(statementPayload);

    if (server_response.status === "OK") {
        const newTransactions = server_response.details.data.transactions;

        dispatch({
            type: "statement",
            payload: {
                transactions: refresh
                    ? newTransactions
                    : state.statement?.transactions
                    ? [...state.statement.transactions, ...newTransactions]
                    : newTransactions,
                summary: server_response.details.data.summary,
            },
        });

        dispatch({ type: "metaData", payload: server_response.details.meta });
    } else {
        dispatch({ type: "statement", payload: "404" });
        dispatch({ type: "metaData", payload: "404" });
    }
};

  

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }


  return(
    <VendorStatementContext.Provider value={{
      ...state, 
      dispatch,
      getStatement,
      setCurrentPage 
      }}>
      {children}
    </VendorStatementContext.Provider>
  )

}

export const useVendorStatement = ()=>useContext(VendorStatementContext);

